import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/ube/features/IncidentDetail/useIncidentDetailForUbe';
import { TagList } from 'core/components/JianDetail/PatientDetailInfo/common/TagList';

type Props = {
  baseInfo: IncidentDetailPatient['baseInfo'];
};

export const BaseInfoView = ({ baseInfo }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="基本情報" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="氏名" content={baseInfo.name} />
          <InfoDisplay title="ふりがな" content={baseInfo.furigana ?? ''} />
          <InfoDisplay title="性別" content={baseInfo.sex ?? ''} />
          <InfoDisplay title="生年月日" content={baseInfo.birthday ?? ''} />
          <InfoDisplay title="年齢" content={baseInfo.age ?? ''} />
          <InfoDisplay
            title="独居"
            content={baseInfo.isLivingAlone ? '該当' : ''}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="傷病者住所"
            content={baseInfo.patientAddress ?? ''}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          {/* 配列だが入力は必ず1人 */}
          <InfoDisplay
            title="関係者氏名"
            content={baseInfo.relatedPersons?.[0]?.name ?? ''}
          />
          <InfoDisplay
            title="関係"
            content={baseInfo.relatedPersons?.[0]?.relationship ?? ''}
          />
          <InfoDisplay
            title="関係者連絡先"
            content={baseInfo.relatedPersons?.[0]?.contact ?? ''}
          />
          <InfoDisplay
            title="関係者連絡の有無"
            content={
              baseInfo.relatedPersons?.[0]?.isContact ? '連絡済' : '未連絡'
            }
          />
          <InfoDisplay
            title="付き添い"
            content={baseInfo.relatedPersons?.[0]?.attendantArrivalType ?? ''}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="預かり品"
            content={<TagList tags={baseInfo.custodyItems.map(item => item)} />}
          />
          <InfoDisplay
            title="預かり品 自由記入欄"
            content={baseInfo?.custodyItemsOther ?? ''}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="連携(1)"
            content={
              <TagList tags={baseInfo.collaboration.map(item => item)} />
            }
          />
          <InfoDisplay title="連携(2)" content={baseInfo.collaborationTiming} />
        </div>
      </div>
    </BorderedContainer>
  );
};
